export default {
  description: 'Returns the not value of an expression or result.',
  usage: ['value.not() → bool'],
  example: {
    description: 'Convert true to false',
    code: 'v.expr(true).not()'
  }
}




// WEBPACK FOOTER //
// ./src/data/api/math_and_logic/not.js